(() => {
  const selector = '[data-kas-checkout]';
  let checkoutPending = false;

  const checkoutUrl = () => `${window.Shopify?.routes?.root || '/'}checkout`;
  const cartUpdateUrl = () => `${window.Shopify?.routes?.root || '/'}cart/update.js`;

  async function setBankTransferChoice(enabled) {
    const response = await fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { havale_indirimi: enabled ? 'true' : null } }),
    });
    if (!response.ok) throw new Error('Ödeme seçimi kaydedilemedi');
  }

  function termsAccepted(button) {
    const container = button.closest('[data-kas-payment-choice]');
    if (container?.dataset.kasTermsRequired !== 'true') return true;
    const scope = button.closest('.m-cart__checkout, .m-cart-drawer__footer') || document;
    const checkbox = scope.querySelector('input[name="agree_terms"]');
    return !checkbox || checkbox.checked;
  }

  function showError(button) {
    const error = button.closest('[data-kas-payment-choice]')?.querySelector('[data-kas-payment-error]');
    if (error) error.hidden = false;
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(selector);
    if (!button || checkoutPending) return;
    event.preventDefault();

    if (!termsAccepted(button)) {
      const scope = button.closest('.m-cart__checkout, .m-cart-drawer__footer') || document;
      scope.querySelector('input[name="agree_terms"]')?.focus();
      return;
    }

    checkoutPending = true;
    document.querySelectorAll(selector).forEach((control) => { control.disabled = true; });
    const originalContent = button.innerHTML;
    button.textContent = button.dataset.loadingText || 'Yönlendiriliyor…';

    try {
      await setBankTransferChoice(button.dataset.kasCheckout === 'bank');
      window.location.assign(checkoutUrl());
    } catch (_error) {
      checkoutPending = false;
      button.innerHTML = originalContent;
      document.querySelectorAll(selector).forEach((control) => { control.disabled = false; });
      showError(button);
    }
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('input[name="agree_terms"]')) return;
    const scope = event.target.closest('.m-cart__checkout, .m-cart-drawer__footer') || document;
    scope.querySelectorAll(selector).forEach((button) => { button.disabled = !event.target.checked; });
  });
})();
